import script from "./GameScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./GameScreen.vue?vue&type=script&setup=true&lang=js"

import "./GameScreen.vue?vue&type=style&index=0&id=67ecbcf9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ecbcf9"]])

export default __exports__